import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/testimonials';
export function TestimonialsSection() {
  return <section className="border-t border-zinc-800 bg-zinc-900 px-5 py-20 md:py-28" data-id="element-167" data-mp="1rv5y0y519t4m">
      <div className="mx-auto max-w-5xl" data-id="element-168" data-mp="1mwuq4syatsp1">
        <SectionHeading title="Lo que dicen sobre el sistema" data-id="element-169" data-mp="1mvtfuqp3xa8d" />
        <ul className="mt-14 grid gap-px overflow-hidden rounded-xl border border-zinc-800 bg-zinc-800 md:grid-cols-2" data-id="element-170" data-mp="1iupw3t3xuu1v">
          {testimonials.map(t => <li key={t.name} className="flex flex-col bg-zinc-950 p-7 md:p-9" data-id="element-171" data-mp="1dubqehpt7w70">
              <div className="flex gap-1 text-gold" role="img" aria-label="5 de 5 estrellas" data-id="element-172" data-mp="18xuzjfr873q8">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-173" data-mp="33auqg5123kct" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 text-lg leading-relaxed text-zinc-100 md:text-xl" data-id="element-174" data-mp="2ybzxia9dkfez">“{t.quote}”</blockquote>
              <p className="mt-auto pt-6 text-sm" data-id="element-175" data-mp="1t9dnh5f4mvku">
                <span className="font-display text-base font-bold uppercase tracking-wide text-zinc-50" data-id="element-176" data-mp="1tbq1j7hrklsm">{t.name}</span>
                <span className="block text-zinc-400" data-id="element-177" data-mp="1jbh6vy3f78fc">{t.role}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}